// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/loss_rate_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { LossRateAreaSetting } from "./loss_rate_model_pb";
import { file_bffuser_v1_loss_rate_model } from "./loss_rate_model_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/loss_rate_service.proto.
 */
export const file_bffuser_v1_loss_rate_service: GenFile = /*@__PURE__*/
  fileDesc("CiJiZmZ1c2VyL3YxL2xvc3NfcmF0ZV9zZXJ2aWNlLnByb3RvEgpiZmZ1c2VyLnYxIh0KG0xpc3RMb3NzUmF0ZVNldHRpbmdzUmVxdWVzdCJOChxMaXN0TG9zc1JhdGVTZXR0aW5nc1Jlc3BvbnNlEi4KBWl0ZW1zGAEgAygLMh8uYmZmdXNlci52MS5Mb3NzUmF0ZUFyZWFTZXR0aW5nMn4KD0xvc3NSYXRlU2VydmljZRJrChRMaXN0TG9zc1JhdGVTZXR0aW5ncxInLmJmZnVzZXIudjEuTGlzdExvc3NSYXRlU2V0dGluZ3NSZXF1ZXN0GiguYmZmdXNlci52MS5MaXN0TG9zc1JhdGVTZXR0aW5nc1Jlc3BvbnNlIgBCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bffuser_v1_loss_rate_model]);

/**
 * ListLossRateSettingsRequest carries no fields. Loss-rate data is a
 * shared master (not tenant-scoped), so no filter criteria are needed.
 *
 * @generated from message bffuser.v1.ListLossRateSettingsRequest
 */
export type ListLossRateSettingsRequest = Message<"bffuser.v1.ListLossRateSettingsRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListLossRateSettingsRequest.
 * Use `create(ListLossRateSettingsRequestSchema)` to create a new message.
 */
export const ListLossRateSettingsRequestSchema: GenMessage<ListLossRateSettingsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_loss_rate_service, 0);

/**
 * @generated from message bffuser.v1.ListLossRateSettingsResponse
 */
export type ListLossRateSettingsResponse = Message<"bffuser.v1.ListLossRateSettingsResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.LossRateAreaSetting items = 1;
   */
  items: LossRateAreaSetting[];
};

/**
 * Describes the message bffuser.v1.ListLossRateSettingsResponse.
 * Use `create(ListLossRateSettingsResponseSchema)` to create a new message.
 */
export const ListLossRateSettingsResponseSchema: GenMessage<ListLossRateSettingsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_loss_rate_service, 1);

/**
 * LossRateService provides a Connect RPC for viewing the transmission/
 * distribution loss-rate master data per area × voltage class (低圧 /
 * 高圧 / 特別高圧).
 *
 * Loss rates are shared master data managed by the SaaS operator, not
 * per-tenant. organization_id is intentionally absent from the request
 * (see docs/specs/admin/master/loss-rate.md).
 * The screen is read-only: eBalance (SaaS 提供者) manages the values
 * (currently by direct DB operation on the shared loss_rate_setting
 * table; an ops-facing edit screen is a future phase), so no mutation
 * RPCs are exposed here.
 *
 * @generated from service bffuser.v1.LossRateService
 */
export const LossRateService: GenService<{
  /**
   * ListLossRateSettings returns loss-rate settings for all 10 areas in
   * a single response. The frontend filters by business-area settings
   * client-side to avoid per-area API calls on tab switch.
   *
   * @generated from rpc bffuser.v1.LossRateService.ListLossRateSettings
   */
  listLossRateSettings: {
    methodKind: "unary";
    input: typeof ListLossRateSettingsRequestSchema;
    output: typeof ListLossRateSettingsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_loss_rate_service, 0);

